import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { emailValidationSchema } from "../../validationSchemas/utilisateur.validation";

const ValidatedEmailForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{
        email: props.email
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values.email);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Adresse E-mail nécessaire";
        } else if (!EmailValidator.validate(values.email)) {
          errors.email = "Adresse E-mail invalide";
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={emailValidationSchema}
    >
      {props => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        return (
          <form name="register" onSubmit={handleSubmit}>
            <Row>
              <Col xs={6}>
                <label htmlFor="email" className="form-label">
                  Adresse E-Mail
                </label>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.email && touched.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Continuer
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
              <Col xs={12}>
                <hr />
                <span>
                  <a
                    className="callToActionLink"
                    onClick={() => navigate("/login")}
                  >
                    Retour
                  </a>{" "}
                </span>
              </Col>
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default ValidatedEmailForm;
